import { useState, ReactNode } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface AccordionItem {
  id: string;
  title: string;
  content: ReactNode;
  onTitleClick?: () => void;
}

interface AccordionProps {
  items: AccordionItem[];
  singleOpen?: boolean;
}

export function Accordion({ items, singleOpen = true }: AccordionProps) {
  const [openItem, setOpenItem] = useState<string | null>(null);

  const toggleItem = (id: string) => {
    setOpenItem((prev) => (singleOpen ? (prev === id ? null : id) : id));
  };

  return (
    <ul className="space-y-1 lg:space-y-2 list-none p-0">
      {items.map((item) => (
        <li key={item.id}>
          <div
            onClick={() => {
              toggleItem(item.id);
              item.onTitleClick?.();
            }}
            className="flex items-center cursor-pointer hover:bg-gray-100 p-1 lg:p-2 rounded text-xs lg:text-sm"
          >
            {openItem === item.id ? (
              <ChevronDown className="w-3 h-3 lg:w-4 lg:h-4 mr-1 lg:mr-2" />
            ) : (
              <ChevronRight className="w-3 h-3 lg:w-4 lg:h-4 mr-1 lg:mr-2" />
            )}
            <span>{item.title}</span>
          </div>

          {openItem === item.id && (
            <div className="pl-4 lg:pl-6 pt-1 lg:pt-2">{item.content}</div>
          )}
        </li>
      ))}
    </ul>
  );
}
